export default function getStaticImageUrl(staticBaseUrl, imagePath) {
  // In Node.js® babel doesn't automatically prefix image path with base url, but webpack in browser does
  if (typeof window === 'undefined') {
    return `${staticBaseUrl}${imagePath}`;
  }

  return imagePath;
}
